<script>
  import helpers from '@mixins/helper'

  export default {
    mixins: [helpers],
    name: 'dashboard-video-popup',
    data () {
      return {
        videoUrl: 'https://www.youtube.com/embed/_U7248FLgH8',
        mostrarModal: true
      }
    },
    computed: {
      isMobileSize: function () {
        return this.isMobile().any()
      }
    }
  }
</script>

<template>
    <v-dialog v-model="mostrarModal"
              :width="isMobileSize ? '98%' : '70%'">
        <v-card>
            <div class="video-wrapper">
                <iframe width="560"
                        height="315"
                        :src="videoUrl"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </div>
        </v-card>
    </v-dialog>
</template>



// WEBPACK FOOTER //
// VideoPopup.vue?0a504860